module.exports = __webpack_public_path__ + "img/qrcode.c6e66a52.jpg";